﻿import Helpers from "./helpers";

export default class FormElementSync {

	static allowChange = true;

	constructor(elementListOne: NodeList, elementListTwo: NodeList) {

		if (!elementListOne.length || !elementListTwo.length) return;

		this.attachEvents(elementListOne, elementListTwo);

	}

	private attachEvents(elementListOne: NodeList, elementListTwo: NodeList) {

		Helpers.scopedLoop(elementListOne, function (element: any, i: any, context: any) {

			element.addEventListener('change', (e: Event) => { context.handleElementChange(e, elementListTwo); });

		}, this);

		Helpers.scopedLoop(elementListTwo, function (element: any, i: any, context: any) {

			element.addEventListener('change', (e: Event) => { context.handleElementChange(e, elementListOne); });

		}, this);

	}

	private handleElementChange(e: Event, elementList: NodeList) {

		const element = e.target as any;
		const value = element.value;

		if (FormElementSync.allowChange) {

			FormElementSync.allowChange = false;

			this.updateValue(elementList, value);

			setTimeout(function () { FormElementSync.allowChange = true; }, 50);

		}

	}

	private updateValue(elementList: NodeList, value: String) {

		const first = elementList[0] as any;
		const type = this.determineType(first);

		if (type === 'select') {

			first.value = value;

			const changeEvent = Helpers.createEventForDispatch('change');
			first.dispatchEvent(changeEvent);

			const blurEvent = Helpers.createEventForDispatch('blur');
			first.dispatchEvent(blurEvent);

		} else if (type === 'radio' || type === 'checkbox') {

			Helpers.scopedLoop(elementList, function (element: any, i: any, context: any) {

				if (element.value === value) {

					element.checked = true;

					const changeEvent = Helpers.createEventForDispatch('change');
					element.dispatchEvent(changeEvent);

				}

			}, this);

		}

	}

	private determineType(element: HTMLElement) {

		let type = element.getAttribute('type') || false;
		if (!type) { type = element.nodeName; }
		type = type.toLowerCase();

		return type;

	}

}
